import axios from '@/axios'

export function getVisualDashboard (params = {}) {
  return axios.get('/dashboard/visual', { params })
}

export function getDashboardVillagesByTown (townCode) {
  return axios.get('/dashboard/villages', { params: { town_code: townCode } })
}

export function getDashboardPlotDetail (params = {}) {
  return axios.get('/dashboard/plot-detail', { params })
}
